module.exports = __webpack_public_path__ + "static/media/azurity-logo-white.b25665a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/azurity-logo-white.svg
// module id = 1379
// module chunks = 0